<app-entity-mat-dialog-title title="Studio Information"></app-entity-mat-dialog-title>
<div mat-dialog-content>
    <mat-progress-spinner class="mx-auto my-3" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

    <form [formGroup]="studioInformationForm">
      <app-success-message [message]="this.successMessage"></app-success-message>
      <app-error-message [message]="this.errorMessage"></app-error-message>

      <!-- Studio Identity -->
      <h6 class="text-muted fw-semibold mb-3">Studio Identity</h6>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Studio Display Name</mat-label>
        <input matInput formControlName="studioDisplayName">
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Studio Email</mat-label>
        <input matInput formControlName="studioEmail">
        <mat-error *ngIf="studioInformationForm.get('studioEmail').invalid">
          Please enter a valid email address.
        </mat-error>
      </mat-form-field>

      <div class="mb-3">
        <label class="form-label text-muted small">Studio Phone Number</label>
        <ngx-intl-tel-input
          [cssClass]="'form-control'"
          [preferredCountries]="['us', 'ca', 'gb', 'au', 'nz', 'de', 'fr', 'es', 'it']"
          [enableAutoCountrySelect]="false"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryPlaceholder]="'Search Country'"
          [selectFirstCountry]="false"
          [selectedCountryISO]="phoneCountry?.toLowerCase()"
          [phoneValidation]="false"
          [separateDialCode]="true"
          name="phone"
          formControlName="studioPhoneNumber"
        ></ngx-intl-tel-input>
        <small class="text-muted d-block mt-1">Select country code from dropdown and enter phone number</small>
        <small *ngIf="studioInformationForm.get('studioPhoneNumber')?.invalid && studioInformationForm.get('studioPhoneNumber')?.touched" class="text-danger d-block mt-1">
          Please enter a valid phone number.
        </small>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country">
              <mat-option *ngFor="let country of this._fieldsService.countries" [value]="country.abbreviation">{{ country.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Currency</mat-label>
            <mat-select formControlName="currencyCode">
              <mat-option value="USD">US Dollar</mat-option>
              <mat-option value="EUR">Euro</mat-option>
              <mat-option value="GBP">British Pound Sterling</mat-option>
              <mat-option value="CAD">Canadian Dollar</mat-option>
              <mat-option value="AUD">Australian Dollar</mat-option>
              <mat-option value="NZD">New Zealand Dollar</mat-option>
              <mat-option value="JPY">Japanese Yen</mat-option>
              <mat-option value="CHF">Swiss Franc</mat-option>
              <mat-option value="SEK">Swedish Krona</mat-option>
              <mat-option value="NOK">Norwegian Krone</mat-option>
              <mat-option value="DKK">Danish Krone</mat-option>
              <mat-option value="PLN">Polish Złoty</mat-option>
              <mat-option value="CZK">Czech Koruna</mat-option>
              <mat-option value="HUF">Hungarian Forint</mat-option>
              <mat-option value="RON">Romanian Leu</mat-option>
              <mat-option value="BGN">Bulgarian Lev</mat-option>
              <mat-option value="HRK">Croatian Kuna</mat-option>
              <mat-option value="RUB">Russian Ruble</mat-option>
              <mat-option value="TRY">Turkish Lira</mat-option>
              <mat-option value="CNY">Chinese Yuan</mat-option>
              <mat-option value="HKD">Hong Kong Dollar</mat-option>
              <mat-option value="SGD">Singapore Dollar</mat-option>
              <mat-option value="TWD">Taiwan Dollar</mat-option>
              <mat-option value="KRW">South Korean Won</mat-option>
              <mat-option value="INR">Indian Rupee</mat-option>
              <mat-option value="IDR">Indonesian Rupiah</mat-option>
              <mat-option value="MYR">Malaysian Ringgit</mat-option>
              <mat-option value="PHP">Philippine Peso</mat-option>
              <mat-option value="THB">Thai Baht</mat-option>
              <mat-option value="VND">Vietnamese Dong</mat-option>
              <mat-option value="MXN">Mexican Peso</mat-option>
              <mat-option value="BRL">Brazilian Real</mat-option>
              <mat-option value="ARS">Argentine Peso</mat-option>
              <mat-option value="CLP">Chilean Peso</mat-option>
              <mat-option value="COP">Colombian Peso</mat-option>
              <mat-option value="PEN">Peruvian Sol</mat-option>
              <mat-option value="UYU">Uruguayan Peso</mat-option>
              <mat-option value="ZAR">South African Rand</mat-option>
              <mat-option value="AED">UAE Dirham</mat-option>
              <mat-option value="SAR">Saudi Riyal</mat-option>
              <mat-option value="ILS">Israeli Shekel</mat-option>
              <mat-option value="EGP">Egyptian Pound</mat-option>
              <mat-option value="NGN">Nigerian Naira</mat-option>
              <mat-option value="KES">Kenyan Shilling</mat-option>
              <mat-option value="MAD">Moroccan Dirham</mat-option>
              <mat-option value="PKR">Pakistani Rupee</mat-option>
              <mat-option value="BDT">Bangladeshi Taka</mat-option>
              <mat-option value="UAH">Ukrainian Hryvnia</mat-option>
              <mat-option value="KZT">Kazakhstani Tenge</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Time Zone</mat-label>
        <mat-select formControlName="studioTimeZone">
          <mat-option *ngIf="filteredTimeZones.length !== timeZones.length" [value]="'show_all'" (click)="showAllTimezones()">
            -- Show All Timezones --
          </mat-option>
          <mat-option *ngFor="let timeZone of filteredTimeZones" [value]="timeZone.value">{{ timeZone.display }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox formControlName="isBonded" class="mb-1">
        This Studio is bonded
      </mat-checkbox>
      <p class="text-muted small mb-0">Check this if your studio has obtained a bond. Bonding may be required in states like Arizona (for prepaid tuition/long-term contracts) and California (for advance payments/prepaid packages). This affects the legal text shown on enrollment agreements.</p>

      <hr class="my-4">

      <!-- Studio Website -->
      <h6 class="text-muted fw-semibold mb-3">Studio Website</h6>

      <div formGroupName="studioWebsite">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Website URI</mat-label>
              <input matInput formControlName="uri">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Website Title</mat-label>
              <input matInput formControlName="title">
            </mat-form-field>
          </div>
        </div>
      </div>

      <hr class="my-4">

      <!-- Studio Address -->
      <h6 class="text-muted fw-semibold mb-3">Studio Address</h6>

      <div formGroupName="studioAddress">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Corporation Name</mat-label>
          <input matInput formControlName="company">
        </mat-form-field>

        <div class="row">
          <div class="col-md-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Franchisee First Name</mat-label>
              <input matInput formControlName="givenName">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Franchisee Last Name</mat-label>
              <input matInput formControlName="familyName">
            </mat-form-field>
          </div>
        </div>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Street Address</mat-label>
          <input matInput formControlName="streetAddress">
        </mat-form-field>

        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>City</mat-label>
              <input matInput formControlName="city">
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ administrativeAreaLabel }}</mat-label>
              <mat-select formControlName="state" *ngIf="internationalAddressService.hasAdministrativeAreas(studioInformationForm.get('country').value)">
                <mat-option *ngFor="let area of internationalAddressService.getAdministrativeAreas(studioInformationForm.get('country').value)"
                            [value]="area.abbreviation">
                  {{ area.name }}
                </mat-option>
              </mat-select>
              <input matInput formControlName="state" *ngIf="!internationalAddressService.hasAdministrativeAreas(studioInformationForm.get('country').value)">
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ postalCodeLabel }}</mat-label>
              <input matInput formControlName="zipCode">
            </mat-form-field>
          </div>
        </div>
      </div>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>VAT / Tax Number (e.g. P.IVA e C.F.)</mat-label>
        <input matInput formControlName="vatNumber">
        <mat-hint>Printed on enrollment agreements that include a company tax line</mat-hint>
      </mat-form-field>
    </form>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary"
          [disabled]="!studioInformationForm.valid || showProgressSpinner"
          (click)="actionType === 'create' ? onSubmit() : onUpdate()">
    <mat-spinner *ngIf="showProgressSpinner" diameter="20" class="d-inline-block"></mat-spinner>
    <span *ngIf="!showProgressSpinner">{{ actionType === 'create' ? 'Save' : 'Update' }}</span>
  </button>
</mat-dialog-actions>
